<template>
  <v-col cols="2">
    <v-menu
      offset-y
      bottom
      left
      transition="slide-y-transition"
      max-width="800"
      :close-on-content-click="false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-list-item v-bind="attrs" v-on="on" class="pointer">
          <v-list-item-avatar>
            <v-avatar color="teal" size="40">
              <v-icon color="white"> mdi-email </v-icon>
            </v-avatar>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="green--text overline">
              NOTIFICHE INFO
            </v-list-item-title>
            <v-list-item-subtitle class="grey--text">
              <template v-if="notifiche_info && notifiche_info.length > 0">
                {{ notifiche_info.length }} Nuovo Messaggio<span
                  v-if="notifiche_info.length > 1"
                  >i</span
                >
              </template>
              <template v-else> Nessun Nuovo Messaggio </template>
            </v-list-item-subtitle>

          </v-list-item-content>
        </v-list-item>
      </template>
      <v-card>
        <v-card-title class="grey--text text-subtitle-1"
          >Notifiche Info</v-card-title
        >
        <v-divider></v-divider>
        <v-card-text>
          <v-list dense>
            <template v-if="notifiche_info && notifiche_info.length > 0">
              <v-list-item
                v-for="(notifica, index) in notifiche_info"
                :key="index"
              >
                <v-list-item-icon>
                  <template v-if="notifica.tipo == 1">
                    <v-icon color="light-blue">mdi-image</v-icon>
                  </template>
                  <template v-else>
                    <v-icon color="orange">mdi-alert</v-icon>
                  </template>
                </v-list-item-icon>
                <v-list-item-content
                  @click.stop="visualizza_notifica(index)"
                  style="cursor: pointer"
                >
                  <v-list-item-title class="subtitle-1">
                    {{ notifica.titolo }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="caption">
                    {{ notifica.testo }}
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn icon>
                    <v-icon
                      color="grey lighten-1"
                      @click.stop="archivia_notifica(notifica.id)"
                      >mdi-arrow-down-bold-box</v-icon
                    >
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </template>
            <template v-else>
              <v-list-item>
                <v-list-item-content>
                  Nessun Nuovo Messaggio
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-list>
        </v-card-text>
      </v-card>
    </v-menu>
    <v-dialog
      v-model="foto_prodotti"
      width="800"
      v-if="notifica_attiva_index !== null"
    >
      <v-card>
        <v-card-title class="grey--text text-subtitle-1"
          >Foto Prodotti Scadute</v-card-title
        >
        <v-divider class="mb-4"></v-divider>
        <v-card-text>
          <template v-if="notifiche_info.length">
            <v-row
              v-for="prodotto in notifiche_info[notifica_attiva_index]
                .risorse_collegate"
              :key="prodotto.id_prodotto"
            >
              <v-col cols="12">
                <v-col cols="12">
                  <v-avatar size="40" class="mr-2">
                    <v-img :src="avatar_img(prodotto.id_prodotto)"></v-img>
                  </v-avatar>
                  {{ get_prodotto(prodotto.id_prodotto).nome }}

                  <v-btn
                    outlined
                    color="red"
                    class="ml-4"
                    @click="elimina_immagini(prodotto.id_prodotto)"
                  >
                    <v-icon class="mr-2"> mdi-delete </v-icon>
                    Cancella Tutto</v-btn
                  >
                </v-col>
              </v-col>
              <v-col cols="12">
                <v-row no-gutters>
                  <v-col v-for="foto in prodotto.imgs_id" :key="foto" cols="3">
                    <v-img
                      height="100"
                      contain
                      :src="foto_prodotto(prodotto.id_prodotto, foto)"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="foto_prodotti = false"> Chiudi </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>


export default {
  name: "notifiche_info",
  data() {
    return {
      loading_archivia: false,
      foto_prodotti: false,
      notifica_attiva_index: null,
    };
  },
  computed: {
    notifiche_info() {
      return this.$store.getters.get_notifiche_info;
    },
  },
  methods: {
    archivia_notifica(id_notifica) {
      this.loading_archivia = true;
      this.$store
        .dispatch("archivia_notifica_info", id_notifica)
        .finally(() => {
          this.loading_archivia = false;
        });
    },
    visualizza_notifica(notifica_index) {
      if (this.notifiche_info[notifica_index].tipo == 1) {
        this.notifica_attiva_index = notifica_index;
        this.foto_prodotti = true;
      }
    },
    elimina_immagini(id_prodotto) {
      let imgs_id = this.notifiche_info[
        this.notifica_attiva_index
      ].risorse_collegate.find(
        (notif) => notif.id_prodotto == id_prodotto
      ).imgs_id;
      this.$store.dispatch("elimina_foto_prodotto_bulk", {
        id_prodotto: id_prodotto,
        imgs_id: imgs_id,
        id_notifica: this.notifiche_info[this.notifica_attiva_index].id,
      });
    },
    get_prodotto(id_prodotto) {
      return this.$store.getters.get_prodotto_by_id(id_prodotto);
    },
    avatar_img(id_prodotto) {
      let item = this.get_prodotto(id_prodotto);
      return (
        process.env.VUE_APP_API_ROOT +
        "/avatar_img/" +
        item.id +
        "?t=" +
        item.avatar_md5
      );
    },
    foto_prodotto(id_prodotto, id_foto) {
      return (
        process.env.VUE_APP_API_ROOT +
        "/prodotto/" +
        id_prodotto +
        "/foto/" +
        id_foto
      );
    },
  },
};
</script>